<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="closeModal()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ info ? 'Edit Vehicle' : 'Create Vehicle' }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form [formGroup]="form" (ngSubmit)="info ? EditNow() : processNow()">
    <div class="form-container">
      <ion-item>
        <ion-input formControlName="name" label="Name" labelPlacement="floating" type="text" maxlength="50"></ion-input>
      </ion-item>
      <!-- 
      <ion-item>
        <ion-label position="floating">Surcharge</ion-label>
        <ion-input formControlName="surcharge" type="number" inputmode="decimal" maxlength="100"></ion-input>
      </ion-item> -->

      <ion-item>
        <ion-input formControlName="seats" label="Seats Number" labelPlacement="floating" type="number"
          inputmode="decimal" maxlength="2" scroll="false"></ion-input>
      </ion-item>

      <div class="avatar-container">
        <ion-avatar (click)="changeImage()">
          <img [src]="previewImage || info?.image || 'assets/imgs/car.svg'" alt="Vehicle Icon">
        </ion-avatar>
        <ion-label>Change Icon</ion-label>
      </div>
    </div>

    <ion-button expand="block" type="submit" [disabled]="form.invalid">
      <ion-icon [name]="info ? 'checkmark-outline' : 'add-outline'" slot="start"></ion-icon>
      {{ info ? 'Update' : 'Create' }}
    </ion-button>
  </form>
</ion-content>